import React from 'react';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import DayJsUtils from '@date-io/dayjs';
import PropTypes from 'prop-types';

function DatePopup(props) {
  return (
    <MuiPickersUtilsProvider utils={DayJsUtils}>
      <KeyboardDatePicker
        autoOk
        format="YYYY-MM-DD"
        inputVariant="standard"
        KeyboardButtonProps={{
          'aria-label': 'open date picker',
        }}
        value={props.value}
        variant="inline"
        onChange={(date) => props.onChange(date)}
      />
    </MuiPickersUtilsProvider>
  );
}

DatePopup.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onChange: PropTypes.func.isRequired,
};

export default DatePopup;
